import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { borderRadius, size } from '@twisto/styles'

export const pickSection = (theme: Theme) => css`
  margin-top: -${size[24]};
  border-top-left-radius: ${borderRadius.xl};
  border-top-right-radius: ${borderRadius.xl};
  background: ${theme.palette.background.primary};
  padding: ${size[48]} ${size[32]};
  text-align: center;
`
